import axios from "axios";
import {  toast } from 'react-toastify';

const requestInstance = axios.create();

let token = localStorage.getItem("token") || "";
requestInstance.interceptors.request.use(
    (config) => {
      const connection = navigator.onLine;
      token = localStorage.getItem("token") || "";
      if (connection === false) {
        toast.error("No Internet Connection");
        return false;
      }
      if (token && (token !== 'undefined' || token !== undefined)) {
        if((config.method === 'patch' || config.method === 'post') && (!config.headers || !config.headers["Content-Type"])){
          config.headers = {
            "Content-Type": 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
          };
        }else{
          config.headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          };
        }
      } else {
        config.headers = {
          "Content-Type": "application/json",
        };
      }
  
      return config;
    },
    (error) => {
      toast.error(error);
      return Promise.reject(error);
    }
  );
  
  // Add a response interceptor
  requestInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      // const navigate = useNavigate();
  
      // if (error?.response?.data) {
      //   toast.error(error?.response?.data?.message);
      // }
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        localStorage.clear();
        window.location.pathname = "/login";
      }
      return Promise.reject(error);
    }
  );
  
  export default requestInstance;